import { useDispatch } from 'react-redux'
import useLightModePreference from '../util/useLightModePreference'
import './GeneralErrorScreen.css'
import { resetTextToImage } from '../vb/actions'

const GeneralErrorScreen = () => {
  const isLightMode = useLightModePreference()
  const dispatch = useDispatch()

  const handleRefresh = () => {
    dispatch(resetTextToImage())
    window.location.reload(true)
  }

  return (
    <div className={`GeneralErrorScreen ${!isLightMode ? 'dark-mode' : ''}`}>
      <div className="GeneralErrorScreen__text">
        <p>Please refresh to continue</p>
        <p>using virtual backgrounds</p>
      </div>

      <button onClick={handleRefresh} className="GeneralErrorScreen__button">
        Refresh virtual background
      </button>
    </div>
  )
}

export default GeneralErrorScreen
